import { render, staticRenderFns } from "./LegendsChip.vue?vue&type=template&id=4b556f78&"
import script from "./LegendsChip.vue?vue&type=script&lang=js&"
export * from "./LegendsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports